const colors = {
  dark: "#0A0A0A",
  white: "#f5f5f5",
};

export default colors;
